export enum FaxResponseStatus {
  FAILED = 'FAILED',
  PROCESSING = 'PROCESSING',
  DELIVERED = 'DELIVERED',
}
